// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".entry--html{width:100%;overflow-x:auto}#tpuan{font-size:12px;background-color:transparent;border-spacing:0}#tpuan thead{background:var(--black);color:var(--white)}#tpuan td,#tpuan th,#tpuan tr{margin:0;border-collapse:collapse;border:1px solid var(--border-divider-100)}#tpuan td{padding:2px;vertical-align:middle;text-align:center}#tpuan tr:nth-child(2n){background-color:#f2f2f2}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
